import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { TraderChatState } from 'src/domains/players/state/traderChat/TraderChatState';
import { ChatWritingArea } from 'src/domains/players/webview/components/Account/traderChat/components/ChatInput.style';
import { observer } from 'src/utils/mobx-react';

export const AutoHeightInput = observer('AutoHeightInput', () => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const configState = ConfigComponents.get(common);
    const { setRef, changeMessage, sendMessageOnEnter } = TraderChatState.get(common);

    const placeholderMessage = languagesState.getTranslation(
        'account.trader-chat.input.placeholder',
        'Type your message here...'
    );

    return (
        <ChatWritingArea
            traderChatVariant={configState.config.componentVariants.traderChatVariant}
            contentEditable={true}
            data-placeholder={placeholderMessage}
            onBlur={changeMessage}
            onInput={changeMessage}
            onKeyDown={sendMessageOnEnter}
            ref={setRef}
            data-test='message-input'
        />
    );
});
